(function() {
    document.body.addEventListener('changelanguage', onLanguageChange);

    function onLanguageChange(e) {
        const el = document.getElementById('order_language');
        if (el) {
            el.value = e.language;
        }
    }
}());

//# sourceMappingURL=lang.js.map
